function isObjectEmpty(object) {
  for (const property in object) {
    if (Object.prototype.hasOwnProperty.call(object, property)) {
      return false;
    }
  }

  return true;
}

export const helpers = {
  isObjectEmpty,
};
